const listItems = document.querySelectorAll('li.menu-item-has-children a');
const goBackBtns = document.querySelectorAll('.Navigation__subMenu__go-back');

const query = window.matchMedia('(max-width: 1024px)');

const initSubMenuFunctionality = () => {
    goBackBtns.forEach((btn) => {
        btn.addEventListener('click', () => {
            const parentUl = btn.closest('ul');
            parentUl.classList.remove('open');
        });
    });

    const handleSubMenu = (ev) => {
        const clickedLink = ev.currentTarget;
        const parent = clickedLink.closest('li');
        if (parent?.classList.contains('Navigation__item')) {
            ev.preventDefault();
        }

        const nestedMenu = parent?.querySelector('ul');
        nestedMenu?.classList.add('open');
    };

    listItems?.forEach((listItem) => listItem.addEventListener('click', handleSubMenu));
};

function handleDesktopHoverState() {
    const menuItems = document.querySelectorAll('.shop-menu .Navigation__subMenu > li');
    menuItems?.forEach((item) => {
        item.addEventListener('mouseenter', () => {
            document.querySelector('main').style.opacity = 0;
        });

        item.addEventListener('mouseleave', () => {
            document.querySelector('main').style.opacity = 1;
        });
    });
}

if (query.matches) {
    initSubMenuFunctionality();
} else {
    handleDesktopHoverState();
}

const handleMenuMobile = (param) => {
    if (param.matches) {
        initSubMenuFunctionality();
    } else {
        handleDesktopHoverState();
    }
};

query.addEventListener('change', handleMenuMobile);
